import { getMembershipsByTeamId } from './getMembershipsByTeamId/getMembershipsByTeamId'
import { membershipsBaseSelectors } from './membershipsBaseSelectors'

export const membershipsSelectors = {
  ...membershipsBaseSelectors,
  getMembershipsByTeamId
}
